import { useCallback, useState } from "react";
import { SearchForm } from "./search-form";
import * as Styled from "./style";
import { UserMenuBlock } from "./user-menu";
import { RightIcons } from "~/components/blocks/layout/global-navi/common/right-icons";
import { useOutsidePointerdown } from "~/hooks/use-outside-pointerdown";

export const Right = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { ref } = useOutsidePointerdown<HTMLDivElement>({
    onOutsidePointerDown: () => setIsVisible(false),
  });
  const onDisplayUserMenu = useCallback(() => {
    setIsVisible((prev) => !prev);
  }, []);
  const onHideUserMenu = useCallback(() => {
    setIsVisible(false);
  }, []);

  return (
    <Styled.DivHeaderRightContainer>
      <SearchForm />
      <div ref={ref}>
        <RightIcons onDisplayUserMenu={onDisplayUserMenu} />
        {isVisible && <UserMenuBlock onHideUserMenu={onHideUserMenu} />}
      </div>
    </Styled.DivHeaderRightContainer>
  );
};
